/** @module Camunda/ToolbarWarning */
define([
	"csi/html",
	"csi/locale",
	"csi/monitor/_base",
	"csi/reflection",
	"csi/service/nodeService",
	"csi/utility/routerUtility",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPlugin",
	"csi/widget/MaterialIconWithLabel"
], function (html, locale, monitor, reflection, nodeService, routerUtility, PluginFactory, ToolbarPlugin, MaterialIconWithLabel) {

	return PluginFactory.declare("camundaWarning", [MaterialIconWithLabel, ToolbarPlugin], {
		"class": `csi-toolbar-warning ${html.CSS_NO_DISPLAY}`,
		icon: "error",
		iconSize: 20,

		/** @property {HTMLElement} anchor - Reference to the link element */
		anchorNode: null,

		/**
		 * @override
		 * Hide plugin to prevent flicker. Plugin will become visible on canShowPlugin 
		 */
		postCreate: function () {
			const url = "centric://REFLECTION/INSTANCE/CamundaGlobal/null";
			const {
				LOCATION_FILTER,
				LOCATION_TAB,
				getLocationForUrl,
			} = routerUtility;

			const href = getLocationForUrl(reflection.URL_SITE, {
				[LOCATION_TAB]: "CamundaTasks",
				[LOCATION_FILTER]: "Issues",
			});

			this.inherited(arguments);
			this.anchorNode = html.a({ href }, this.labelNode);

			// by default labelNode is hidden if no "label" attribute
			html.setVisible(this.labelNode, true);

			// request node first time and monitor thereafter
			nodeService.resolveNode(url).then((node) => this._onChanges(node));
			this.own(monitor.onChangeNode(url, (newNode) => this._onChanges(newNode)));
		},

		/**
		 * Monitor's on change call back
		 * @param {Node} node
		 */
		_onChanges: function (node) {
			const { NumberOfTasksWithIssues } = node;
			const param = (NumberOfTasksWithIssues === 1) ? locale.type("CamundaTask") : locale.typePlural("CamundaTask");
			this.anchorNode.innerText = locale.parameterResource("CamundaTaskRequiredAttention", [NumberOfTasksWithIssues, param]);

			if (this.domNode) {
				this.domNode.classList.toggle(html.CSS_NO_DISPLAY, !NumberOfTasksWithIssues);
			}
		}
	});
});
